/**
 * @export
 * @class Global
 */
// @ts-ignore
import SmoothScroll from "smooth-scroll";

import { BaseModule } from "../../helpers/base_module";
import { Accordions } from "../../modules/accordions";
/* import { Cookies } from "../../modules/cookies"; */
import { InlineFaqs } from "../../modules/inline-faq";
import { Parallax } from "../../modules/parallax";
import { ReactiveBackgrounds } from "../../modules/reactive-backgrounds";
import { StickyNavs } from "../../modules/sticky-navs";
import { Validation } from "../../modules/validation";

import { Navigation } from "./navigation";
import { PageHeaders } from "./page-headers";
import { SiteHeader } from "./site-header";
import { SiteSearch } from "./site-search";
import { videoPlayer } from "./videoPlayer";

export class Global extends BaseModule {
  public static id = "*";
  public scroll: SmoothScroll;

  /**
   * Creates an instance of Global.
   *
   * @memberof Global
   */
  constructor() {
    super();
    super.makePublic("global");

    // Create our smoothScroll object
    this.scroll = new SmoothScroll('a[href*="#"]', {
      speed: 600,
      offset: 103,
      updateURL: false,
      // @ts-ignore
      speedAsDuration: true,
    });

    this.videoPlayer();

    new SiteHeader();
    new PageHeaders();
    new Navigation();
    new Parallax();
    new InlineFaqs();
    /*     new Cookies(); */
    new Accordions();
    new Validation();
    new StickyNavs();
    new SiteSearch();
    new ReactiveBackgrounds();

    void this.loadOptionalModules();
  }

  private videoPlayer(): void {
    videoPlayer();
  }

  private async loadOptionalModules(): Promise<void> {
    await this.loadGalleries();
    await this.loadBlocks();
    void this.loadSelectBoxes();
  }

  private async loadGalleries(): Promise<void> {
    if (!document.querySelector("[data-gallery]")) {
      window.app.modules.galleries = {
        getGallery: () => undefined,
      };
      return;
    }

    const { Galleries } = await import("../../modules/gallery");
    new Galleries();
  }

  private async loadBlocks(): Promise<void> {
    if (!document.querySelector(".js-content-slider, .js-drag-slider, .js-media-slider, .js-locations, .js-faqs")) {
      return;
    }

    const { Blocks } = await import("./blocks");
    new Blocks();
  }

  private async loadSelectBoxes(): Promise<void> {
    if (!document.getElementsByTagName("select").length) {
      return;
    }

    const { SelectBoxes } = await import("./select-boxes");
    new SelectBoxes();
  }
}
